import { Box, Paper } from '@mui/material';

import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint';

export const FloatingBox = ({ children }: { children: React.ReactNode }) => {
  const { isMobile } = useBreakpoint();
  const shunt = '-30%';
  return (
    <Box sx={{ backgroundColor: 'white', display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Paper
        elevation={2}
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifySelf: 'center',
          paddingX: 3.75,
          paddingY: '15px',
          transform: `translateY(${shunt})`,
          width: isMobile ? '100%' : 'auto',
        }}
      >
        {children}
      </Paper>
    </Box>
  );
};
